import { render } from "./InterfaceSelectMobile.vue?vue&type=template&id=2fcab0ca&scoped=true"
import script from "./InterfaceSelectMobile.vue?vue&type=script&lang=js"
export * from "./InterfaceSelectMobile.vue?vue&type=script&lang=js"

import "./InterfaceSelectMobile.vue?vue&type=style&index=0&id=2fcab0ca&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcab0ca"]])

export default __exports__